import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';
import { Github, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <div>
            {/* Newsletter Section */}
            <section className="newsletter-section">
                <div className="newsletter-container">
                    <div className="newsletter-content">
                        <h2>Stay Updated</h2>
                        <p>Get the latest product updates and company news delivered to your inbox.</p>
                    </div>
                    <form className="newsletter-form">
                        <input type="email" className="newsletter-input" placeholder="Enter your email" required />
                        <button type="submit" className="subscribe-btn">Subscribe</button>
                    </form>
                </div>
            </section>

            {/* Main Footer */}
            <footer className="main-footer">
                <div className="footer-container">
                    <div className="footer-grid">
                        {/* Brand Column */}
                        <div className="footer-brand">
                            <div className="footer-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                                <svg
                                    className="product-icon"
                                    viewBox="0 0 100 100"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M 20 35 L 45 35"
                                        stroke="#1E40AF"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path
                                        d="M 20 50 L 55 50"
                                        stroke="#14B8A6"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path
                                        d="M 20 65 L 65 65"
                                        stroke="#F59E0B"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path d="M 45 35 L 55 40 L 45 45 Z" fill="#1E40AF"></path>
                                    <path d="M 55 50 L 65 55 L 55 60 Z" fill="#14B8A6"></path>
                                    <path d="M 65 65 L 75 70 L 65 75 Z" fill="#F59E0B"></path>
                                    <circle cx="80" cy="50" r="8" fill="#1E40AF"></circle>
                                </svg>
                                <span className="logo-text">SequFlow</span>
                            </div>
                            <p className="footer-description">
                                Complete suite of enterprise and consumer products — unified design, consistent experience, built for scale.
                            </p>
                            <div className="social-links">
                                <a href="#" className="social-link" aria-label="GitHub">
                                    <Github size={18} />
                                </a>
                                <a href="#" className="social-link" aria-label="Twitter">
                                    <Twitter size={18} />
                                </a>
                                <a href="#" className="social-link" aria-label="LinkedIn">
                                    <Linkedin size={18} />
                                </a>
                            </div>
                        </div>

                        {/* Features Column */}
                        <div className="footer-column">
                            <h3>Products</h3>
                            <ul className="footer-links">
                                <li><a href="#" onClick={(e) => { e.preventDefault(); navigate('/task-management'); }}>Task Management</a></li>
                                <li><a href="#">Core suite</a></li>
                                <li><a href="#">Vertical Solutions</a></li>
                                <li><a href="#">Daliy APPa</a></li>
                                <li><a href="#">SequMail</a></li>
                                <li><a href="#">SequConnect</a></li>
                                <li><a href="#">SequHub</a></li>
                            </ul>
                        </div>

                        {/* Resources Column */}
                        <div className="footer-column">
                            <h3>Company</h3>
                            <ul className="footer-links">
                                <li><a href="#">About Us</a></li>
                                <li><a href="#">Careers</a></li>
                                <li><a href="#">Case Studies</a></li>
                                <li><a href="#">Support</a></li>
                               
                            </ul>
                        </div>

                        {/* Explore Column */}
                        <div className="footer-column">
                            <h3>Legal & Compliance
            
                            </h3>
                            <ul className="footer-links">
                                <li><a href="#">Terms of service</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="#">Cookie Policy</a></li>
                                <li><a href="#">GDPR</a></li>
                                <li><a href="#">Trademark Policy</a></li>
                               
                            </ul>
                        </div>

                        {/* Compare Column */}
                        <div className="footer-column">
                            <h3>Security & Safety</h3>
                            <ul className="footer-links">
                                <li><a href="#">Security Policy</a></li>
                                <li><a href="#">lPR Complaints</a></li>
                                <li><a href="#">Anti Spam Policy</a></li>
                                <li><a href="#">Compliance</a></li>
                                <li><a href="#">Abuse Policy</a></li>
                             
                            </ul>
                        </div>

                        {/* Legal Column */}
                        <div className="footer-column">
                            <h3>Legal & Compliance</h3>
                            <ul className="footer-links">
                                <li><a href="#">Terms of Service</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="#">Cookie Policy</a></li>
                                <li><a href="#">GDPR</a></li>
                                <li><a href="#">Security Policy</a></li>
                                <li><a href="#">IPR Complaints</a></li>
                                <li><a href="#">Abuse Policy</a></li>
                            </ul>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="footer-bottom">
                        <div className="copyright">
                            © 2026 SequFlow Pvt. Ltd. All Rights Reserved.
                        </div>
                        <div className="footer-bottom-links">
                            <a href="#">Sitemap</a>
                            <a href="#">Accessibility</a>
                            <a href="#">Status</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
